import { createFileRoute } from '@tanstack/react-router'
import { PopularDomains, ToolPage } from '@/components/tool-page/tool-page'
import { toolHead } from '@/components/tool-page/tool-head'
import { SslTool } from '@/components/tool-page/ssl-tool'
import { POPULAR_SITES } from '@/lib/popular-sites'
import { TOOLS } from '@/lib/tool-content'

const content = TOOLS['ssl-checker']

export const Route = createFileRoute('/_site/tools/ssl-checker')({
  component: SslCheckerPage,
  validateSearch: (search: Record<string, unknown>): { q?: string } => ({
    q: typeof search.q === 'string' && search.q ? search.q : undefined,
  }),
  head: () => toolHead(content),
})

function SslCheckerPage() {
  const { q } = Route.useSearch()
  return (
    <ToolPage content={content} extra={<PopularDomains toolPath="/tools/ssl-checker" heading="Check the SSL certificate of a popular site" sites={POPULAR_SITES} />}>
      <SslTool content={content} initialHost={q ?? ''} autoRun={!!q} />
    </ToolPage>
  )
}
